module.exports = __webpack_public_path__ + "img/calcas.6e610867.png";